import { createSelector } from '@reduxjs/toolkit';
import { entitiesSelector } from "./base";
import { combinedSheetSelector } from "./sheets";
import { orderByPosition } from "../../../lib/utils";
export const sectionsSelector = createSelector(entitiesSelector, ({
  sections
}) => sections);
export const sectionPreviewSelector = createSelector(sectionsSelector, combinedSheetSelector, (sections, sheets) => {
  const getSectionInformation = ({
    section_id,
    ...sheet
  }) => {
    const {
      position
    } = sections.find(({
      id
    }) => id === section_id) || {};
    const updateSheet = {
      ...sheet,
      section_id,
      position
    };
    return updateSheet;
  };
  return sheets.map(getSectionInformation).sort(orderByPosition);
});